import React from 'react'
import { Skeleton } from 'antd'
import { FormComponent } from '../../../BaseComponent'
import { ShelterContextData } from '../../../../context/ShelterContext'
import KioskForm from '../../Kiosk'
import KioskBranchList from '../../../KioskBranchList'
import { KioskContextData } from '../../../../context/KioskContext'
import { ShelterKioskReasonContextData } from '../../../../context/ShelterKioskReasonContext'
import { LanguageConsumer } from '../../../../context/LanguageContext'
import IKiosk from '../../../../interfaces/IKiosk'
import KioskDetail from './KioskDetail'
import IBranch from '../../../../interfaces/IBranch'
import RegisterKiosk from './Register'

export type KioskProps = {
  shelterUuid: string,
  branchUuid: string,

  history: any,

  context: ShelterContextData
  kioskContext: KioskContextData
  shelterKioskReasonContext: ShelterKioskReasonContextData
}

export default class Kiosk extends FormComponent<KioskProps> {

  state = {
    loaded: !!this.props.context.shelter,

    currentKioskView: null,
    currentKioskCreate: null
  }

  async componentDidMount() {
    await this.load()

    this.setState({
      loaded: true
    })
  }

  private async load() {
    const { shelterUuid, context } = this.props

    if (shelterUuid) {
      await context.requestShelterFind({
        search: {
          uuid: shelterUuid,
          contract_options: {
            with: {
              deleted: false
            }
          },
          organization_question_shelters: {
            with: {
              deleted: false,
              kiosk_reason_id: null,
              question_shelter_species: {
                with: true
              }
            }
          },
          organization_branches: {
            with: {
              deleted: false,
              kiosk_reasons: {
                with: {
                  deleted: false
                }
              },
              kiosks: {
                with: {
                  active: true,
                  deleted: false
                }
              }
            }
          }
        },
        options: {
          _force_ids: true
        }
      })
    }
  }

  handleShowKiosks = (kiosk: IKiosk) => {
    this.setState({
      currentKioskView: kiosk
    })
  }

  handleKioskDetailClose = () => {
    this.setState({
      currentKioskView: null
    })
  }

  handleKioskCreate = (branch: IBranch) => {
    this.setState({
      currentKioskCreate: branch
    })
  }

  handleKioskCreateClose = (finished?: boolean) => {
    this.setState({
      currentKioskCreate: null
    }, async () => {
      if (finished) {
        await this.load()
      }
    })
  }

  render() {
    const { branchUuid, shelterUuid, kioskContext, shelterKioskReasonContext, history, context } = this.props
    const { loaded, currentKioskView, currentKioskCreate } = this.state

    if (!loaded) {
      return <Skeleton />
    }

    if (branchUuid) {
      return (
        <LanguageConsumer>
          {({ languages, requestLanguageList }) => (
            <KioskForm
              branchUuid={branchUuid}
              shelterUuid={shelterUuid}
              loading={kioskContext.fetching || false}
              error={kioskContext.error}
              history={history}
      
              kioskReasons={kioskContext.kioskReasons || []}
              shelterKioskReason={shelterKioskReasonContext}
              languages={languages}
      
              loadKioskReason={kioskContext.requestKioskReasonList}
              loadLanguages={requestLanguageList}
            />
          )}
        </LanguageConsumer>
      )
    }

    return (
      <div>
        <KioskBranchList
          branches={context.shelter?.organization_branches}
          loading={context.fetching || false}
          history={null}
          onKioskShow={this.handleShowKiosks}
          onKioskCreate={this.handleKioskCreate}
        />

        {
          currentKioskView && (
            <KioskDetail
              kiosk={currentKioskView as any}
              onClose={this.handleKioskDetailClose}
            />
          )
        }

        {
          currentKioskCreate && (
            <RegisterKiosk
              branch={currentKioskCreate as any}
              kioskContext={kioskContext}
              onClose={this.handleKioskCreateClose}
            />
          )
        }
      </div>
    )
  }
}
